const CloseIcon = ({ width, height, color, handleClick }) => {
  return (
    <div
      onClick={handleClick}
      style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
    >
      <svg
        fill="none"
        viewBox="0 0 20 20"
        width={width || "20"}
        height={height || "20"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.414 10L17.707 3.707C17.8945 3.51949 17.9999 3.26518 17.9999 3C17.9999 2.73483 17.8945 2.48051 17.707 2.293C17.5195 2.10549 17.2652 2.00015 17 2.00015C16.7348 2.00015 16.4805 2.10549 16.293 2.293L10 8.586L3.707 2.293C3.61416 2.20016 3.50393 2.12651 3.38263 2.07626C3.26132 2.02601 3.1313 2.00015 3 2.00015C2.8687 2.00015 2.73868 2.02601 2.61738 2.07626C2.49607 2.12651 2.38585 2.20016 2.293 2.293C2.10549 2.48051 2.00015 2.73483 2.00015 3C2.00015 3.26518 2.10549 3.51949 2.293 3.707L8.586 10L2.293 16.293C2.10549 16.4805 2.00015 16.7348 2.00015 17C2.00015 17.2652 2.10549 17.5195 2.293 17.707C2.48051 17.8945 2.73483 17.9999 3 17.9999C3.26518 17.9999 3.51949 17.8945 3.707 17.707L10 11.414L16.293 17.707C16.3857 17.8002 16.4958 17.8741 16.6171 17.9246C16.7385 17.9751 16.8686 18.001 17 18.001C17.1314 18.001 17.2615 17.9751 17.3829 17.9246C17.5042 17.8741 17.6143 17.8002 17.707 17.707C17.7999 17.6142 17.8737 17.504 17.924 17.3827C17.9743 17.2614 18.0002 17.1313 18.0002 17C18.0002 16.8687 17.9743 16.7386 17.924 16.6173C17.8737 16.496 17.7999 16.3858 17.707 16.293L11.414 10Z"
          fill={color || "black"}
        />
      </svg>
    </div>
  );
};

export default CloseIcon;
